import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
const PrivacyTextIntegration = styled.div.withConfig({
  displayName: "CustomTermsAndConditions__PrivacyTextIntegration",
  componentId: "sc-1l0rnke-0"
})(["margin-bottom:8px;margin-top:25px;line-height:24px;"]);
export const StyledPrivacyBanner = styled.div.withConfig({
  displayName: "CustomTermsAndConditions__StyledPrivacyBanner",
  componentId: "sc-1l0rnke-1"
})(["margin-top:20px;", ""], props => props.theme.embedded && `margin-top: 2px;`);
export const CustomTermsAndConditions = ({
  children,
  LegitimateInterest
}) => {
  return /*#__PURE__*/_jsx(StyledPrivacyBanner, {
    className: "text-center",
    children: /*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: [/*#__PURE__*/_jsx(PrivacyTextIntegration, {
        children: children
      }), LegitimateInterest]
    })
  });
};